const NewProductIds = ["40060","40061", "40072", "40062", "40063", "40064", "40069", "40066", "40068","40059","40071", "40075", "40078", "40076"]
export default NewProductIds